export default __webpack_public_path__ + "static/media/nobanner.7ad9466f.jpg";